import DirectDepositManagementScreen from 'features/directDeposit/screens/DirectDepositManagementScreen';
import React from 'react';
import { PinwheelContextProvider } from 'shared/providers/pinwheel/PinwheelContextProvider/PinwheelContextProvider';

export default function DirectDepositManagementPage() {
  return (
    <PinwheelContextProvider>
      <DirectDepositManagementScreen />
    </PinwheelContextProvider>
  );
}
